import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';
import { AssetGallery } from '@Components/AssetManager';

export default function Assets() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Admin', href: '/' },
          { name: 'Assets', href: '/asset-manager' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Asset Manager</Heading>
        </div>
      </div>
      <AssetGallery />
    </div>
  );
}
